import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { ILeistungskatalogSpediteur } from '../_interfaces/leistungskatalog-spediteur';
import { IChoiceList } from '../_interfaces/_choice-list';
import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable()
export class LeistungskatalogSpediteurService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'id', type: 'int'},
    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
    {name: 'artikelnummer', type: 'string'},
    {name: 'artikelbezeichnung', type: 'string'},
    {name: 'mengeneinheit', type: 'string'},
    {name: 'preis', type: 'decimal'},
    {name: 'leistungId', type: 'string'},
    {name: 'summary', type: 'string'}
  ];
    
  getLeistungskatalogSpediteurCollection(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ leistungskatalogSpediteur: ILeistungskatalogSpediteur[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'leistungskatalogspediteur?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          return { leistungskatalogSpediteur: <ILeistungskatalogSpediteur[]>response.body, pagination: <IPagination>JSON.parse(response.headers.get('x-pagination')) };
        }), catchError(this.handleError))
  }

  getLeistungskatalogSpediteurForLeistung(leistung: string): Observable<ILeistungskatalogSpediteur[]> {
    return this.httpClient.get<ILeistungskatalogSpediteur[]>(this.apiBaseUrl + 'leistungskatalogspediteur/leistung/' + leistung, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError));
  }

  getLeistungskatalogSpediteur(id: number): Observable<ILeistungskatalogSpediteur> {

    if (id === 0) {
      // return Observable.create((observer: any) => {
      //   observer.next(this.initializeLeistungskatalogSpediteur());
      //   observer.complete();
      // })
      return of(this.initializeLeistungskatalogSpediteur());
    }

    return this.httpClient.get<ILeistungskatalogSpediteur>(this.apiBaseUrl + 'leistungskatalogspediteur/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError));
  }

  saveLeistungskatalogSpediteur(leistungskatalogSpediteur: ILeistungskatalogSpediteur): Observable<ILeistungskatalogSpediteur> {
    // DateTimeOffset-Fix
    let itemToSave = cloneDeep(leistungskatalogSpediteur); // clonen, um sicherzustellen, dass das Original-Objekt nicht ver�ndert wird, evtl. passiert nach dem Save noch etwas damit ?
    //console.log("LeistungskatalogSpediteurService.saveSingularCapitalized#() itemToSave before DateTimeOffset-Fix:", itemToSave);
    this.propertyTypes.filter(f => f.type.toLowerCase() == 'datetimeoffset').forEach(propertyType => {
      if (itemToSave[propertyType.name] != null) {
        itemToSave[propertyType.name] = moment(itemToSave[propertyType.name]).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // alle datetimeoffset-felder entspr. formatieren, dass in der API auch der Offset ankommt!
      }
    });
    //console.log("LeistungskatalogSpediteurService.saveSingularCapitalized#() itemToSave after DateTimeOffset-Fix:", itemToSave);

    if (leistungskatalogSpediteur.id === 0) {
      return this.createLeistungskatalogSpediteur(/*leistungskatalogSpediteur*/itemToSave);
    }

    return this.updateLeistungskatalogSpediteur(/*leistungskatalogSpediteur*/itemToSave)

  }

  updateLeistungskatalogSpediteur(leistungskatalogSpediteur: ILeistungskatalogSpediteur): Observable<ILeistungskatalogSpediteur> {

    return this.httpClient.put<ILeistungskatalogSpediteur>(this.apiBaseUrl + 'leistungskatalogspediteur/' + leistungskatalogSpediteur.id, leistungskatalogSpediteur, { headers: httpOptions, observe: 'body', withCredentials: true })
    .pipe(catchError(this.handleError))

  }

  deleteLeistungskatalogSpediteur(id: number) {

    return this.httpClient.delete(this.apiBaseUrl + 'leistungskatalogspediteur/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(
        catchError(this.handleError)
      )
  }

  createLeistungskatalogSpediteur(leistungskatalogSpediteur: ILeistungskatalogSpediteur): Observable<ILeistungskatalogSpediteur> {
    return this.httpClient.post<ILeistungskatalogSpediteur>(this.apiBaseUrl + 'leistungskatalogspediteur', leistungskatalogSpediteur, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError))
  }

  initializeLeistungskatalogSpediteur(): ILeistungskatalogSpediteur {
    return {
      id: 0,
      createdBy: '',
      created: '',
      modifiedBy: '',
      modified: '',
      rowVersion: '',
      artikelnummer: '',
      artikelbezeichnung: '',
      mengeneinheit: '',
      preis: 0,
      leistungId: '',
      summary: ''
    };
  }


}
